import React from 'react';
import LinkWithQuery from '../LinkWithQuery';

const SubHeader = ({ onMouseMove, onMouseLeave, activeId }) => {
	return (
		<div className="c-navbar__menu" onMouseMove={onMouseMove} onMouseLeave={onMouseLeave}>
			<div className="c-cat-menu" style={{ display: activeId === 'Hearing-Aids' ? 'block' : 'none' }}>
				<div className="o-wrapper">
					<div className="c-cat-menu__grid">
						<div className="c-cat-menu__grid-col c-cat-menu__grid-col--border-r">
							<div className="o-row-1p5">
								<p className="c-cat-menu__heading">Hearing Aids</p>
							</div>
							<p className="c-cat-menu__copy">
								We carry the top rated hearing aids from the leading manufacturers in the industry. Click on the links
								to see an overview of the latest technology and prices.
							</p>
						</div>
						<div className="c-cat-menu__grid-col">
							<div className="c-cat-menu-options">
								<div className="c-cat-menu-options__col">
									<ul className="c-cat-menu__items">
										<li className="c-cat-menu__item">
											<LinkWithQuery className="c-cat-menu__link" to="/hearing-aids/horizon/">
												Horizon Hearing Aids
											</LinkWithQuery>
										</li>
										<li className="c-cat-menu__item">
											<LinkWithQuery className="c-cat-menu__link" to="/hearing-aids/">
												Hearing Aids
											</LinkWithQuery>
										</li>
										<li className="c-cat-menu__item">
											<LinkWithQuery className="c-cat-menu__link" to="/hearing-aids/prices/">
												Prices
											</LinkWithQuery>
										</li>
									</ul>
								</div>
								<div className="c-cat-menu-options__col">
									<ul className="c-cat-menu__items">
										<li className="c-cat-menu__item">
											<LinkWithQuery className="c-cat-menu__link" to="/hearing-aids/technology/">
												Technology
											</LinkWithQuery>
										</li>
										<li className="c-cat-menu__item">
											<LinkWithQuery className="c-cat-menu__link" to="/hearing-aids/brands/">
												Manufacturers
											</LinkWithQuery>
										</li>
										<li className="c-cat-menu__item">
											<LinkWithQuery className="c-cat-menu__link" to="/resources/hearing-aids/guide-to-price-value/">
												How to Choose A Hearing Aid
											</LinkWithQuery>
										</li>
									</ul>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div className="c-cat-menu" style={{ display: activeId === 'Hearing-Loss' ? 'block' : 'none' }}>
				<div className="o-wrapper">
					<div className="c-cat-menu__grid">
						<div className="c-cat-menu__grid-col c-cat-menu__grid-col--border-r">
							<div className="o-row-1p5">
								<p className="c-cat-menu__heading">Hearing Loss</p>
							</div>
							<p className="c-cat-menu__copy">
								We only work with the most knowledgeable experts in the industry. The pages to the right provide
								information about hearing loss and how hearing aids can help.
							</p>
						</div>
						<div className="c-cat-menu__grid-col">
							<div className="c-cat-menu-options">
								<div className="c-cat-menu-options__col">
									<ul className="c-cat-menu__items">
										<li className="c-cat-menu__item">
											<LinkWithQuery className="c-cat-menu__link" to="/hearing-loss/">
												Hearing Loss
											</LinkWithQuery>
										</li>
										<li className="c-cat-menu__item">
											<LinkWithQuery className="c-cat-menu__link" to="/hearing-loss/symptoms/">
												Symptoms
											</LinkWithQuery>
										</li>
										<li className="c-cat-menu__item">
											<LinkWithQuery className="c-cat-menu__link" to="/hearing-loss/sudden/">
												Sudden
											</LinkWithQuery>
										</li>
									</ul>
								</div>
								<div className="c-cat-menu-options__col">
									<ul className="c-cat-menu__items">
										<li className="c-cat-menu__item">
											<LinkWithQuery className="c-cat-menu__link" to="/hearing-loss/sensorineural/">
												Sensorineural
											</LinkWithQuery>
										</li>
										<li className="c-cat-menu__item">
											<LinkWithQuery className="c-cat-menu__link" to="/hearing-loss/conductive/">
												Conductive
											</LinkWithQuery>
										</li>
									</ul>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div className="c-cat-menu" style={{ display: activeId === 'Resources' ? 'block' : 'none' }}>
				<div className="o-wrapper">
					<div className="c-cat-menu__grid">
						<div className="c-cat-menu__grid-col c-cat-menu__grid-col--border-r">
							<div className="o-row-1p5">
								<p className="c-cat-menu__heading">Resources</p>
							</div>
							<p className="c-cat-menu__copy">
								Explore our resource center for expert recommendations, answers to frequently asked questions, and the
								most relevant information on modern hearing care.
							</p>
						</div>
						<div className="c-cat-menu__grid-col">
							<div className="c-cat-menu-options">
								<div className="c-cat-menu-options__col">
									<ul className="c-cat-menu__items">
										<li className="c-cat-menu__item">
											<LinkWithQuery className="c-cat-menu__link" to="/resources/hearing-loss/">
												Hearing Loss
											</LinkWithQuery>
										</li>
										<li className="c-cat-menu__item">
											<LinkWithQuery className="c-cat-menu__link" to="/resources/hearing-aids/">
												Hearing Aids
											</LinkWithQuery>
										</li>
										<li className="c-cat-menu__item">
											<LinkWithQuery className="c-cat-menu__link" to="/resources/hearing-aid-success/">
												Hearing Aids Success
											</LinkWithQuery>
										</li>
									</ul>
								</div>
								<div className="c-cat-menu-options__col">
									<ul className="c-cat-menu__items">
										<li className="c-cat-menu__item">
											<LinkWithQuery className="c-cat-menu__link" to="/faqs/">
												FAQ
											</LinkWithQuery>
										</li>
										<li className="c-cat-menu__item">
											<LinkWithQuery className="c-cat-menu__link" to="/hearing-test/">
												Hearing Test
											</LinkWithQuery>
										</li>
										<li className="c-cat-menu__item">
											<LinkWithQuery className="c-cat-menu__link" to="/resources/videos/">
												Videos
											</LinkWithQuery>
										</li>
									</ul>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div className="c-cat-menu" style={{ display: activeId === 'About-Us' ? 'block' : 'none' }}>
				<div className="o-wrapper">
					<div className="c-cat-menu__grid">
						<div className="c-cat-menu__grid-col c-cat-menu__grid-col--border-r">
							<div className="o-row-1p5">
								<p className="c-cat-menu__heading">About Us</p>
							</div>
							<p className="c-cat-menu__copy">
								hear.com provides free consultations and top-of-the-line hearing aids. Your perfect hearing aid is just
								a phone call away! Request a consultation now.
							</p>
						</div>
						<div className="c-cat-menu__grid-col">
							<div className="c-cat-menu-options">
								<div className="c-cat-menu-options__col">
									<ul className="c-cat-menu__items">
										<li className="c-cat-menu__item">
											<LinkWithQuery className="c-cat-menu__link" to="/about-us/why-hear/">
												Why hear.com
											</LinkWithQuery>
										</li>
										<li className="c-cat-menu__item">
											<LinkWithQuery className="c-cat-menu__link" to="/about-us/the-experience/">
												The hear.com Experience
											</LinkWithQuery>
										</li>
										<li className="c-cat-menu__item">
											<LinkWithQuery className="c-cat-menu__link" to="/about-us/network/">
												Our Network
											</LinkWithQuery>
										</li>
									</ul>
								</div>
								<div className="c-cat-menu-options__col">
									<ul className="c-cat-menu__items">
										<li className="c-cat-menu__item">
											<LinkWithQuery className="c-cat-menu__link" to="/about-us/testimonials/">
												Testimonials
											</LinkWithQuery>
										</li>
										<li className="c-cat-menu__item">
											<LinkWithQuery className="c-cat-menu__link" to="/about-us/awards/">
												Awards
											</LinkWithQuery>
										</li>
									</ul>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default SubHeader;
